// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__zLGgz","item":"styles_item__UX3L-","item_email":"styles_item_email__dAXT8"};